import { Pipe, PipeTransform } from '@angular/core';
import { CURRENCY_LABEL, PERCENT_LABEL } from '@app/_helpers';
import { PriceType } from '../../../../utProto/webApiStrategyEnums_pb';

@Pipe({
  name: 'percentPipe'
})
export class PercentPipe implements PipeTransform {

  transform(value: string, type: number): string {
    if (value === null ||
      value === undefined ||
      value === '') {
      return value;
    }

    if (type === PriceType.PRICETYPE_PERCENTANGE) {
      return value + PERCENT_LABEL;
    }
    return CURRENCY_LABEL + value;
  }

}
